import React, { useEffect, useState, useRef } from "react";

import Typography from "@mui/material/Typography";
// import logo from "../_images/LogoLimited.png";
import Grid from "@mui/material/Grid";
import IdentityVerificationCard from "./components/IdentityVerificationCard";
import ThankYouCard from "./components/ThankYouCard";
import UnauthorizedCard from "./components/UnauthorizedCard";
import ToDo from "./ToDo";

import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { langConversionHelper, utilities } from "@/_helpers";

import {
  loadDocuments,
  saveReportSignature,
  saveCompletedReport,
  unloadReport,
  loadCompletedDocument,
  loadTemplate,
} from "../_redux/actions/documentActions";

import SaveOverlay from "@/_components/SaveOverlay";

// import Review from "../documents/Review";
import Review from "./Review";
import Upload from "../documents/Upload";

import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";

import ElectronicSignatureAgreement from "../documents/fillable/ElecronicSignatureAgreement";
import PARestorationRequirementsLetter from "../documents/fillable/PARestorationRequirementsLetter";
import PAElectronicPaperwork from "../documents/fillable/PAElectronicPaperwork";
import { uploadDocument, getDocuments } from "../_api/documentsApi";
import { expireSecureLink, validateSecureLink } from "../_api/usersApi";
// import { expireSecureLink, validateSecureLink,getUser } from "../_api/usersApi";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

// function a11yProps(index) {
//     return {
//         id: `simple-tab-${index}`,
//         "aria-controls": `simple-tabpanel-${index}`,
//     };
// }

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // [theme.breakpoints.up("md")]: { padding: theme.spacing(4) },
    // [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
  },
  toolbar: theme.mixins.toolbar,
  tabBar: {
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    maxWidth: "100vw",
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(4),
      marginTop: 20,
      marginLeft: 20,
    },
    [theme.breakpoints.down("md")]: { padding: theme.spacing(2) },
  },
  bodyGrid: {
    //style={{ paddingLeft: 10, paddingRight: 10 }}
    [theme.breakpoints.up("sm")]: { paddingLeft: 10, paddingRight: 10 },
    [theme.breakpoints.down("sm")]: { paddingLeft: 1 },
  },
  headerGrid: {
    [theme.breakpoints.only("sm")]: { padding: 10 },
    [theme.breakpoints.down("sm")]: { paddingTop: 10, paddingBottom: 10 },
  },
}));
const setSessionItem = (key, value) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + 30 * 60 * 1000,
    // expiry: now.getTime() + 10 * 1000
  };
  sessionStorage.setItem(key, JSON.stringify(item));
};

const cardType = {
  thankYou: "ThankYou",
  unauthorized: "unauthorized",
  identityCard: "IdentityCard",
  displayDocument: "displayDocument",
};

const SignNowPage = ({
  // notifications,
  // onNotificationsUpdate,
  // loadNotifications,
  // documents,
  // documentTab,
  loadDocuments,
  loadTemplate,
  // completedDocument,
  // loadCompletedDocument,
  // documentTabChange,
  saveReportSignature,
  saveCompletedReport,
  report,
  // ...props
}) => {
  const cookies = new Cookies();
  const [showCard, setShowCard] = useState(cardType.identityCard);

  // const locale = countryCode === "USA" ? enUS : enAU;
  // const countryCode = sessionStorage.getItem("LSCountryCode");
  const [timeLeft, setTimeLeft] = useState(null);
  // const user = cookies.get("lifesaferUser");

  const [user, setUser] = useState(null);

  // const [userInfo, setUserInfo] = useState(null)
  const countInvalidResponse = useRef(0);

  // this is for documents
  // const isMountedRef = useRef(null);
  const [toDoList, setToDoList] = useState([{ CurrentState: "Undefined" }]);
  // const [completedList, setCompletedList] = useState([
  //     { CurrentState: "Undefined" },
  // ]);
  const [currentComponent, setCurrentComponent] = useState("Main");
  const [reviewDocID, setReviewDocID] = useState(null);
  const [appointmentID, setAppointmentID] = useState(null);
  const [vehicleID, setVehicleID] = useState(null);
  const [jurisdictionID, setJurisdictionID] = useState(null);
  const [locationID, setLocationID] = useState(null);
  const [reportType, setReportType] = useState(null);
  const [reportName, setReportName] = useState(null);
  const [reportID, setReportID] = useState(null);
  const [canShowReport, setCanShowReport] = useState(false);
  const [selectedUploadTypeID, setSelectedUploadTypeID] = useState(0);
  const [selectedUploadName, setSelectedUploadName] = useState(null);
  // const [selectedCompletedName, setSelectedCompletedName] = useState(null);
  // const [selectedCompletedPath, setSelectedCompletedPath] = useState(null);
  // const [selectedCompleted, setSelectedCompleted] = useState(null);
  // const [showNoDocsCard, setShowNoDocsCard] = useState(false);
  const [savingDoc, setSavingDoc] = useState(false);
  const [documents, setDocuments] = useState([]);
  const { t, i18n } = useTranslation();
  document.title = "LifeSafer - Documents";
  const classes = useStyles();
  // const [value, setValue] = useState(0);
  const value = 0;
  const isSignNowPageStyle = true;
  // doucments

  let expiryInterval = null;
  const [submitting, setSubmitting] = useState(false);
  const token = useRef(null);
  const [timerRed, setTimerRed] = useState(false);

  useEffect(() => {
    cookies.remove("lifesaferUser", { path: "/" });
    const path = window.location.pathname;
    token.current = path.replace("/signnow/", "");
    // token.current =
    //   "aDlnUWhFdHJOYVZxdzAvVmFXRHNDTmpmck9EbW5SRzcycGlpcEk5cEJwME5FL1RVc0VnY0xQYzN2QzJEYlVlaE5aNXhyYlB5YmRMVDdMdFdLQ2w1aGVmQmhJZEN6RkJU";
  }, []);

  useEffect(() => {
    // sessionStorage.removeItem("userLastName");
    // sessionStorage.removeItem("userDob");
    const lastNameItem = getSessionItem("userLastName");
    const dobItem = getSessionItem("userDob");
    if (lastNameItem && dobItem) {
      let obj = {
        LastName: lastNameItem.value,
        DOB: dobItem.value,
        page: "My Account Sign Now",
        token: token.current,
      };

      setShowCard(cardType.displayDocument);
      handleIdentityVerification(obj, false);
    }
    // startExpiryTimer()
    return () => {
      if (expiryInterval) clearInterval(expiryInterval);
    };
  }, []);

  const getSessionItem = (key) => {
    const itemStr = sessionStorage.getItem(key);
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item?.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }
    return item || null;
  };

  const formatTime = (ms) => {
    if (ms == null) return "";
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const startExpiryTimer = () => {
    if (expiryInterval) clearInterval(expiryInterval);

    expiryInterval = setInterval(() => {
      const now = new Date();
      const lastNameItem = getSessionItem("userLastName");
      const dobItem = getSessionItem("userDob");

      if (!lastNameItem || !dobItem) {
        sessionStorage.removeItem("userLastName");
        sessionStorage.removeItem("userDob");
        setShowCard(cardType.unauthorized);
        setTimeLeft(null);
        clearInterval(expiryInterval);
        return;
      }

      const diff = lastNameItem.expiry - now;

      if (diff <= 1000) {
        sessionStorage.removeItem("userLastName");
        sessionStorage.removeItem("userDob");
        secureLinkExpire();
        setShowCard(cardType.unauthorized);
        clearInterval(expiryInterval);
      } else {
        setTimeLeft(diff);
        let fiveMinTime= 5 * 60 * 1000;
        if (diff < fiveMinTime + 1000) {
          setTimerRed(true);
        }
      }
    }, 1000);
  };

  const handleIdentityVerification = (obj, setSession = true) => {
    setSubmitting(true);
    obj.token = token.current;
    validateSecureLink(obj)
      .then((x) => {
        cookies.set("lifesaferUser", JSON.stringify(x), {
          path: "/",
          sameSite: "strict",
        });
        if (setSession) {
          setSessionItem("userLastName", obj.LastName);
          setSessionItem("userDob", obj.DOB);
        }
        setUser(x);
        startExpiryTimer();
        checkTotalDocument(x);
        setShowCard(cardType.displayDocument);
      })
      .catch((error) => {
        let errMess = error.message;
        errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
        toast.error(t("toasts.updateFailed") + " " + errMess);
        countInvalidResponse.current += 1;

        // expire link for 3 invalid response
        if (countInvalidResponse.current === 3) {
          secureLinkExpire();
          setShowCard("unauthorized");
        }
        sessionStorage.removeItem("userLastName");
        sessionStorage.removeItem("userDob");
        setSubmitting(false);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const secureLinkExpire = () => {
    let expireObj = {
      token: token.current,
      page: "My Account Sign Now",
    };
    expireSecureLink(expireObj)
      .then((x) => {
        console.log("successfully expired", x);
      })
      .catch(() => {
        console.log("error");
      });
  };

  const handleViewExample = (uploadTypeID, uploadName) => {
    setSelectedUploadTypeID(uploadTypeID);
    setSelectedUploadName(uploadName);

    toast.info(t("documents.viewExample"), { autoClose: 10000 });

    let currentLangID = langConversionHelper.findLanguageID(i18n.language);

    loadTemplate(currentLangID, uploadName)
      .then((template) => {
        //let fileName = "Example_" + templateDesc + ".pdf";
        if (template === null || template.length === 0) {
          console.log("Template Load Failure");
          // Language Unsupported Load English
          loadTemplate(1, uploadName)
            .then((template) => {
              if (
                template === null ||
                template === false ||
                template.length === 0
              ) {
                console.log("Template Load Final Failure!");
              } else {
                utilities.handlePDFOpen(template.fileBase64Value);
              }
            })
            .catch((err) => {
              toast.error(err.message);
            });
        } else {
          utilities.handlePDFOpen(template.fileBase64Value);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const handleReviewDocInfo = (
    i,
    // docPath,
    appointmentID,
    jurisdictionID,
    locationID,
    reportType,
    reportName,
    vehicleID
  ) => {
    // if (!isMountedRef.current) return null;
    setCurrentComponent("Review");
    setAppointmentID(appointmentID);
    setJurisdictionID(jurisdictionID);
    setLocationID(locationID);
    setReportType(reportType);
    setReportName(reportName);
    setCanShowReport(true);
    setReviewDocID(i);
    setVehicleID(vehicleID);
  };

  const showFileUploadComponent = (uploadTypeID, uploadName) => {
    setSelectedUploadTypeID(uploadTypeID);
    setSelectedUploadName(uploadName);
    setCurrentComponent("Upload");
  };

  const handleTemplateClick = (documentObject) => {
    setReportType(documentObject.type);
    setReportName(documentObject.name);
    setReportID(documentObject.id);
    setJurisdictionID(documentObject.jurisdictionID);
    setVehicleID(documentObject.vehicleID);
    setAppointmentID(documentObject.appointmentID);
    setLocationID(documentObject.locationID);
    setCurrentComponent(documentObject.type);
  };

  const handleSetCanShowReport = (bCanShow) => {
    setCanShowReport(bCanShow);
  };

  //this is for documents end
  // const handleViewCompleted = (fileName, completedPath) => {
  //     setSelectedCompletedName(fileName);
  //     setSelectedCompletedPath(completedPath);
  //     setCurrentComponent("ViewCompleted");
  // };

  // const handleChange = (event, newValue) => {
  //     setValue(newValue);
  //     documentTabChange(newValue);
  //     setCurrentComponent("Main");
  // };

  const handleClose = () => {
    setCanShowReport(false);
    unloadReport();
    setCurrentComponent("Main");
  };

  const handleFormSaved = () => {
    toast.success(t("documents.saveCompletedReportSuccess"));
    loadDocuments(user.clientID, user.userID, user.languageID).then(() => {
      handleClose();
    });
  };

  const handleSaveUserSignature = (userSignatureData) => {
    if (
      userSignatureData.userId == null ||
      userSignatureData.userId == undefined ||
      userSignatureData.userId == 0 ||
      userSignatureData.reportSignatureId == null ||
      userSignatureData.reportSignatureId == undefined ||
      userSignatureData.reportSignatureId == 0
    ) {
      toast.info("User signature not saved");
    } else {
      saveReportSignature(userSignatureData).catch((error) => {
        console.log("Save user signature failed! " + error);
      });
      toast.success(t("documents.userSignatureSaveSuccess"));
    }
  };

  const handleSaveCompletedReport = (completedReportData) => {
    if (
      completedReportData.userId == null ||
      completedReportData.userId == undefined ||
      completedReportData.userId == 0 ||
      completedReportData.clientID == null ||
      completedReportData.reportID == null ||
      completedReportData.appointmentID == null ||
      completedReportData.jurisdictionID == null
    ) {
      toast.info("Completed report not saved");
    } else {
      setSavingDoc(true);
      saveCompletedReport(completedReportData)
        .then(() => {
          loadDocuments(
            completedReportData.clientID,
            user.userId,
            user.languageID
          ).then(() => {
            handleClose();
            setSavingDoc(false);
            toast.success(t("documents.saveCompletedReportSuccess"));
          });
        })
        .catch((error) => {
          console.log("Save completed report failed! " + error);
          setSavingDoc(false);
          toast.error(t("documents.saveError"));
        });
    }
  };

  const handleUploadDocument = (uploadDocumentData) => {
    uploadDocument(
      uploadDocumentData.userId,
      uploadDocumentData.clientID,
      uploadDocumentData.uploadTypeID,
      uploadDocumentData.uploadFile
    )
      .then((resultSet) => {
        if (resultSet === null || resultSet === false) {
          toast.error(t("documents.documentUploadFailed"));
        } else {
          toast.success(t("documents.documentUploadSuccess"));
          loadDocuments(
            uploadDocumentData.clientID,
            user.userId,
            user.languageID
          );
          handleClose();
        }
      })
      .catch((err) => {
        toast.error(t("documents.documentUploadFailed") + " " + err.message);
      });
  };

  function handleSignNowSubmit() {
    checkTotalDocument(user);
  }

  function checkTotalDocument(UserData) {
    let clientId = UserData?.clientID;
    let userId = UserData?.userID;
    let languageId = UserData?.languageID;

    getDocuments(clientId, userId, languageId)
      .then((x) => {
        setToDoList(x);
        setDocuments(x);
        let resDocument = x;
        const totalDocuments = resDocument.length;
        const totalCompletedtodoDocuments = resDocument.filter(
          (x) => x.complete === true
        );

        if (totalDocuments === totalCompletedtodoDocuments.length) {
          setShowCard(cardType.thankYou);
          secureLinkExpire();
        } else {
          setShowCard(cardType.displayDocument);
        }
      })
      .catch((e) => {
        console.log("errorr", e);
      })
      .finally(() => {});
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        {/* <Grid
          container
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: "20px",
          }}
        >
          <Grid item>
            <img src={logo} />
            <Typography
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                color: "rgb(28, 53, 94)",
                fontSize: "40px",
                marginTop:"-10px"
              }}
            >
              {t("registration.secureSign")}
            </Typography>
          </Grid> */}

        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ paddingTop: "20px" }}
        >
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img src={"./src/_images/LogoLimited.png"} alt="LifeSafer" />
            <Typography
              variant="h4"
              sx={{
                // padding: "1rem",
                color: "#1c355e",
                fontWeight: "bold",
                textAlign: "center",
                fontSize: "40px",
              }}
            >
              {t("registration.secureSign")}
            </Typography>
          </Grid>

          {showCard == "ThankYou" && <ThankYouCard />}

          {showCard == "IdentityCard" && (
            <IdentityVerificationCard
              submitting={submitting}
              handleIdentityVerification={handleIdentityVerification}
            />
          )}

          {showCard == "unauthorized" && <UnauthorizedCard />}
        </Grid>

        {showCard == "displayDocument" && (
          <>
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "rgb(28, 53, 94)",
                  fontSize: "20px",
                }}
              >
                {t("securepay.sessionTimer")}{" "}
                <span style={{ color: timerRed ? "red" : "" }}>
                  {timeLeft ? formatTime(timeLeft) : "--"}
                </span>
              </Typography>

              <Typography
                sx={{
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "rgb(28, 53, 94)",
                  fontSize: "20px",
                }}
              >
                {t("securepay.client")} {user?.clientName || "N/A"}
              </Typography>
            </Grid>

            <div className={classes.root}>
              {currentComponent === "Main" ||
              currentComponent === "Review" ||
              currentComponent === "Upload" ||
              currentComponent === "Template" ||
              currentComponent === "ViewCompleted" ? (
                <>
                  {/* {(toDoList === undefined ||
                                        toDoList[0].CurrentState === "Undefined") &&
                                        showNoDocsCard === false ? (
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            style={{ marginTop: 50 }}
                                        >
                                            <PageLoader />
                                        </Grid>
                                    ) : showNoDocsCard === true ? (
                                        <div>
                                            <div className={classes.toolbar} />
                                            <NoDocuments></NoDocuments>
                                        </div>
                                    ) : toDoList[0].CurrentState === "None" ? (
                                        <div className={classes.tabBar}>
                                            <StyledTabs value={value} onChange={handleChange}>
                                                <StyledTab
                                                    label={t("documents.Completed")}
                                                    icon={<AssignmentTurnedInIcon />}
                                                    iconPosition="start"
                                                    {...a11yProps(0)}
                                                />
                                            </StyledTabs>
                                        </div>
                                    ) : (
                                        <div className={classes.tabBar}>
                                            <StyledTabs value={value} onChange={handleChange}>
                                                <StyledTab
                                                label={t("documents.ToDO")}
                                                icon={<ListAltIcon />}
                                                iconPosition="start"
                                                {...a11yProps(0)}
                                            />
                                            <StyledTab
                                                label={t("documents.Completed")}
                                                icon={<AssignmentTurnedInIcon />}
                                                iconPosition="start"
                                                {...a11yProps(0)}
                                            />
                                            </StyledTabs>
                                        </div>
                                    )} */}
                  {/* {toDoList === undefined ||
                                        toDoList[0] === undefined ||
                                        toDoList[0].CurrentState === "Undefined" ? null : toDoList[0]
                                            .CurrentState === "None" ? (
                                        <TabPanel value={1} index={1}>
                                            {currentComponent === "Main" ? (
                                                <>
                                                    <Completed viewCompleted={handleViewCompleted} user={user} />
                                                </>
                                            ) : currentComponent === "ViewCompleted" ? (
                                                <Grid container direction="row" item xs={12}>
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        className={classes.headerGrid}
                                                    >
                                                        <Grid container item justifyContent="flex-end">
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                className={classes.bodyGrid}
                                                            >
                                                                <ViewCompleted
                                                                    fileName={selectedCompletedName} // todo: can remove?
                                                                    selectedCompleted={selectedCompleted}
                                                                    handleClose={handleClose}
                                                                ></ViewCompleted>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                <></>
                                            )}
                                        </TabPanel>
                                    ) : ( */}
                  <>
                    <TabPanel value={value} index={0}>
                      {currentComponent === "Main" ? (
                        <>
                          <ToDo
                            user={user}
                            toDoRows={toDoList}
                            viewExample={handleViewExample}
                            reviewDocInfo={handleReviewDocInfo}
                            handleFileUpload={showFileUploadComponent}
                            handleTemplateClick={handleTemplateClick}
                            canShowReport={canShowReport}
                            handleSetCanShowReport={handleSetCanShowReport}
                            report={report}
                            documents={documents}
                          />
                        </>
                      ) : currentComponent === "Review" ||
                        currentComponent === "Upload" ? (
                        <Grid container direction="row" item xs={12}>
                          {savingDoc === true ? (
                            <>
                              <Grid
                                container
                                direction="row"
                                className={classes.headerGrid}
                              >
                                <Grid item style={{ padding: 5 }}>
                                  <SaveOverlay
                                    open={savingDoc}
                                    setOpen={setSavingDoc}
                                  ></SaveOverlay>
                                </Grid>
                              </Grid>
                            </>
                          ) : (
                            <></>
                          )}
                          <Grid
                            container
                            direction="row"
                            className={classes.headerGrid}
                          >
                            {currentComponent === "Review" ? (
                              <Grid container item justifyContent="flex-end">
                                <Grid
                                  container
                                  direction="row"
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Review
                                    iDocID={reviewDocID}
                                    appointmentID={appointmentID}
                                    jurisdictionID={jurisdictionID}
                                    locationID={locationID}
                                    reportType={reportType}
                                    reportName={reportName}
                                    vehicleID={vehicleID}
                                    handleClose={handleClose}
                                    saveReportSignature={
                                      handleSaveUserSignature
                                    }
                                    saveCompletedReport={
                                      handleSaveCompletedReport
                                    }
                                    user={user}
                                  ></Review>
                                </Grid>
                              </Grid>
                            ) : currentComponent === "Upload" ? (
                              <Grid container item justifyContent="flex-end">
                                <Grid
                                  container
                                  direction="row"
                                  style={{ paddingLeft: 10, paddingRight: 10 }}
                                >
                                  <Upload
                                    selectedUploadTypeID={selectedUploadTypeID}
                                    selectedUploadName={selectedUploadName}
                                    handleClose={handleClose}
                                    handleUploadDocument={handleUploadDocument}
                                    isSignNowPageStyle={isSignNowPageStyle}
                                  ></Upload>
                                </Grid>
                              </Grid>
                            ) : (
                              <></>
                            )}
                          </Grid>
                        </Grid>
                      ) : currentComponent === "Template" ? (
                        <>
                          {reportID === 966 && (
                            <ElectronicSignatureAgreement
                              handleClose={handleClose}
                              handleFormSaved={handleFormSaved}
                              userID={user.userID}
                              clientID={user.clientID}
                              jurisdictionID={jurisdictionID}
                              reportID={reportID}
                              vehicleID={vehicleID}
                              appointmentID={appointmentID}
                              languageID={user.languageID}
                              formDescription={reportName}
                              handleSignNowSubmit={handleSignNowSubmit}
                            />
                          )}
                          {reportID === 967 && (
                            <PARestorationRequirementsLetter
                              handleClose={handleClose}
                              handleFormSaved={handleFormSaved}
                              userID={user.userID}
                              clientID={user.clientID}
                              jurisdictionID={jurisdictionID}
                              reportID={reportID}
                              vehicleID={vehicleID}
                              appointmentID={appointmentID}
                              languageID={user.languageID}
                              formDescription={reportName}
                            />
                          )}
                          {reportID === 976 && (
                            <PAElectronicPaperwork
                              handleClose={handleClose}
                              handleFormSaved={handleFormSaved}
                              userID={user.userID}
                              clientID={user.clientID}
                              jurisdictionID={jurisdictionID}
                              reportID={reportID}
                              vehicleID={vehicleID}
                              locationID={locationID}
                              appointmentID={appointmentID}
                              languageID={user.languageID}
                              formDescription={reportName}
                            />
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </TabPanel>
                  </>
                  {/* )} */}

                  {/* {value === 1 &&
                                        (completedList === undefined ||
                                            completedList[0] === undefined ||
                                            completedList[0].CurrentState === "Undefined") ? (
                                        <div>
                                            <PageLoader />
                                        </div>
                                    ) : (
                                        <>
                                            <TabPanel value={value} index={1}>
                                                {currentComponent === "Main" ? (
                                                    <>
                                                        <Completed
                                                            viewCompleted={handleViewCompleted}
                                                            user={user}
                                                        />
                                                    </>
                                                ) : currentComponent === "ViewCompleted" ? (
                                                    <Grid container direction="row" item xs={12}>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            className={classes.headerGrid}
                                                        >
                                                            <Grid container item justifyContent="flex-end">
                                                                <Grid
                                                                    container
                                                                    direction="row"
                                                                    className={classes.bodyGrid}
                                                                >
                                                                    <ViewCompleted
                                                                        fileName={selectedCompletedName} // todo : can remove?
                                                                        selectedCompleted={selectedCompleted}
                                                                        handleClose={handleClose}
                                                                    ></ViewCompleted>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                ) : (
                                                    <></>
                                                )}
                                            </TabPanel>
                                        </>
                                    )} */}
                </>
              ) : (
                <></>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

SignNowPage.propTypes = {
  loadDocuments: PropTypes.func,
  loadTemplate: PropTypes.func,
  documentTabChange: PropTypes.func,
  saveReportSignature: PropTypes.func,
  saveCompletedReport: PropTypes.func,
  report: PropTypes.array,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number,
  index: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    documents: state.documents,
    notifications: state.notifications,
    report: state.report,
    selectedUploadTypeID: state.selectedUploadTypeID,
    appointmentID: state.appointmentID,
    vehicleID: state.vehicleID,
    jurisdictionID: state.jurisdictionID,
    locationID: state.locationID,
    reportType: state.reportType,
    reportName: state.reportName,
    completedDocument: state.completedDocument,
  };
}

const mapDispatchToProps = {
  //   loadNotifications,
  loadDocuments,
  saveReportSignature,
  saveCompletedReport,
  unloadReport,
  loadCompletedDocument,
  loadTemplate,
};

// export default SignNowPage;
export default connect(mapStateToProps, mapDispatchToProps)(SignNowPage);
